<template>
    <div class="cookie-alert" v-if="isNotAccepted">
        <div v-text="$t('cookie-text')"/>
        <div class="_2">
            <button class="save-btn" type="button" @click="accept()" v-text="$t('cookie-btn-accept')"/>
            <a href="https://sovis.com.br/politica-privacidade/" target="_blank" v-text="$t('cookie-link')"/>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isNotAccepted: !localStorage.cookieAccepted
        }
    },
    methods: {
        accept() {
            localStorage.cookieAccepted = true;
            this.isNotAccepted = !localStorage.cookieAccepted;
        }
    }
    
}
</script>
<style lang="scss" scoped>

.cookie-alert {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: $orange;
    color: $sovis-white;
    font-size: 14px;
    padding: 16px;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
        text-align: justify;
        &._2 {
            text-align: center;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            align-items: center;
        }
    }
    a {
        margin-left: 20px;
        font-weight: 600;

        &:hover {
            color: $primary-color-click;
        }
    }
}

</style>